import { colors } from '../../colors';
var address = {
  addressColor: colors.smoke
};
export default address;